import React from "react";

export const Pricing = (props) => {
  const features = [
    { name: "Delayed replay", free: true, starter: true, pro: true, analyzer: true },
    { name: "Pause and analyse", free: true, starter: true, pro: true, analyzer: true },
    { name: "Save to library", free: true, starter: true, pro: true, analyzer: true },
    { name: "Cast to second device", free: false, starter: true, pro: true, analyzer: true },
    { name: "Automatic slow motion replay", free: false, starter: false, pro: true, analyzer: true },
    { name: "Auto-pause replay", free: false, starter: false, pro: true, analyzer: true },
    { name: "Automatic save", free: false, starter: false, pro: true, analyzer: true },
    { name: "Bowling analysis", free: false, starter: false, pro: false, analyzer: true },
    { name: "Golf analysis", free: false, starter: false, pro: false, analyzer: true },
    { name: "Email support", free: false, starter: true, pro: true, analyzer: true },
  ];

  const plans = [
    { 
      name: "Free", 
      price: "$0",
      yearly: null,
      monthly: null,
      highlight: false,
      key: "free"
    },
    { 
      name: "Starter", 
      price: null,
      yearly: "$9.99",
      monthly: "$0.99",
      highlight: false,
      key: "starter"
    },
    { 
      name: "Pro", 
      price: null,
      yearly: "$19.99",
      monthly: "$1.99",
      highlight: true,
      key: "pro"
    },
    { 
      name: "Analyzer", 
      price: null,
      yearly: "$29.99",
      monthly: "$2.99",
      highlight: false,
      key: "analyzer"
    },
  ];

  const getFeatureValue = (feature, planKey) => {
    return feature[planKey];
  };

  return (
    <section id="features" className="atf-pricing-area atf-section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="atf-section-title text-center wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s" data-wow-offset="0">
              <h2 className="">Plans and Pricing</h2>
            </div>
          </div>
        </div>

        {/* Desktop Table View */}
        <div className="row justify-content-center d-none d-lg-flex" style={{marginTop: '30px'}}>
          <div className="col-lg-12">
            <div style={{overflowX: 'auto'}}>
              <table style={{width: '100%', borderCollapse: 'collapse', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
                <thead>
                  <tr style={{borderBottom: '2px solid var(--thm-black)'}}>
                    <th style={{padding: '20px 15px', textAlign: 'left', fontSize: '18px', fontWeight: 'bold', color: 'var(--thm-black)'}}>Features</th>
                    {plans.map((plan, idx) => (
                      <th key={idx} style={{
                        padding: '20px 15px', 
                        textAlign: 'center', 
                        fontSize: '18px', 
                        fontWeight: 'bold',
                        backgroundColor: plan.highlight ? 'yellowgreen' : 'white',
                        color: plan.highlight ? 'white' : 'var(--thm-black)',
                        borderLeft: idx > 0 ? '1px solid #ddd' : 'none'
                      }}>
                        <div style={{fontSize: '24px', marginBottom: '8px', fontWeight: 'bold'}}>{plan.name}</div>
                        {plan.price ? (
                          <div style={{fontSize: '32px', fontWeight: 'bold', marginTop: '10px', letterSpacing: '-0.5px'}}>{plan.price}</div>
                        ) : (
                          <div style={{marginTop: '12px', fontSize: '24px', fontWeight: 'bold', letterSpacing: '-0.5px'}}>
                            <span>{plan.yearly}*</span>
                            <span style={{fontSize: '16px', opacity: 0.85, fontWeight: 'normal', marginLeft: '4px'}}>/year</span>
                          </div>
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {features.map((feature, idx) => (
                    <tr key={idx} style={{borderBottom: idx < features.length - 1 ? '1px solid #eee' : 'none'}}>
                      <td style={{padding: '15px', fontSize: '16px', color: 'var(--thm-black)'}}>{feature.name}</td>
                      <td style={{padding: '15px', textAlign: 'center', borderLeft: '1px solid #ddd'}}>
                        {feature.free ? <span style={{color: 'green', fontSize: '20px'}}>✓</span> : <span style={{color: '#ccc'}}>—</span>}
                      </td>
                      <td style={{padding: '15px', textAlign: 'center', borderLeft: '1px solid #ddd'}}>
                        {feature.starter ? <span style={{color: 'green', fontSize: '20px'}}>✓</span> : <span style={{color: '#ccc'}}>—</span>}
                      </td>
                      <td style={{padding: '15px', textAlign: 'center', borderLeft: '1px solid #ddd', backgroundColor: 'rgba(154, 205, 50, 0.1)'}}>
                        {feature.pro ? <span style={{color: 'green', fontSize: '20px'}}>✓</span> : <span style={{color: '#ccc'}}>—</span>}
                      </td>
                      <td style={{padding: '15px', textAlign: 'center', borderLeft: '1px solid #ddd'}}>
                        {feature.analyzer ? <span style={{color: 'green', fontSize: '20px'}}>✓</span> : <span style={{color: '#ccc'}}>—</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p style={{fontSize: "12px", textAlign: 'center', marginTop: '15px', color: '#666'}}>* USD. Prices vary per region.</p>
          </div>
        </div>

        {/* Mobile Card View */}
        <div className="row justify-content-center d-flex d-lg-none" style={{marginTop: '30px'}}>
          {plans.map((plan, planIdx) => (
            <div key={planIdx} className="col-12 col-md-6" style={{marginBottom: '20px'}}>
              <div className="atf-pricing-content" style={{
                backgroundColor: plan.highlight ? 'yellowgreen' : 'white',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                border: plan.highlight ? '2px solid yellowgreen' : '1px solid #ddd',
                minHeight: '100%'
              }}>
                <div style={{textAlign: 'center', marginBottom: '20px'}}>
                  <h3 style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    color: plan.highlight ? 'white' : 'var(--thm-black)'
                  }}>
                    {plan.name}
                  </h3>
                  {plan.price ? (
                    <div style={{
                      fontSize: '36px',
                      fontWeight: 'bold',
                      color: plan.highlight ? 'white' : 'var(--thm-black)',
                      letterSpacing: '-0.5px'
                    }}>
                      {plan.price}
                    </div>
                  ) : (
                    <div style={{
                      fontSize: '28px',
                      fontWeight: 'bold',
                      color: plan.highlight ? 'white' : 'var(--thm-black)',
                      letterSpacing: '-0.5px',
                      marginTop: '5px'
                    }}>
                      <span>{plan.yearly}*</span>
                      <span style={{
                        fontSize: '18px',
                        opacity: 0.9,
                        fontWeight: 'normal',
                        marginLeft: '4px'
                      }}>
                        /year
                      </span>
                    </div>
                  )}
                </div>
                <div style={{
                  borderTop: `1px solid ${plan.highlight ? 'rgba(255,255,255,0.3)' : '#eee'}`,
                  paddingTop: '15px'
                }}>
                  <ul style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0
                  }}>
                    {features.map((feature, featureIdx) => {
                      const hasFeature = getFeatureValue(feature, plan.key);
                      return (
                        <li key={featureIdx} style={{
                          padding: '10px 0',
                          borderBottom: featureIdx < features.length - 1 ? `1px solid ${plan.highlight ? 'rgba(255,255,255,0.2)' : '#f0f0f0'}` : 'none',
                          fontSize: '15px',
                          color: plan.highlight ? 'white' : 'var(--thm-black)',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}>
                          <span>{feature.name}</span>
                          <span style={{
                            fontSize: '18px',
                            color: hasFeature ? 'green' : '#ccc',
                            fontWeight: 'bold'
                          }}>
                            {hasFeature ? '✓' : '—'}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          ))}
          <div className="col-12">
            <p style={{fontSize: "12px", textAlign: 'center', color: '#666'}}>* USD. Prices vary per region.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
